import classNames from "classnames";
import type { FormFieldOption, FormState, HandleInputChange } from "./types";
import { hashEncode } from "@/utility";

type CheckboxInputProps = {
    name: string;
    options: Array<FormFieldOption | string>;
    stacked?: boolean;
    disabled?: boolean;
    formState: FormState;
    onChange: HandleInputChange;
};

const normalizeOption = (option: FormFieldOption | string): FormFieldOption => {
    if (typeof option === "string") {
        return { label: option, value: option };
    }
    return option;
};

const CheckboxInput = ({
    name,
    options,
    stacked = false,
    disabled = false,
    formState,
    onChange,
}: CheckboxInputProps) => {
    const normalizedOptions = options.map(normalizeOption);

    return (
        <div>
            {normalizedOptions.map((opt) => {
                const idValue = `${name}-${opt.value}`
                const optId = `${idValue}-${hashEncode(idValue)}`;
                const optionName = (opt.name as string) || name;

                return (
                    <div key={String(opt.label)} className={classNames("form-check", { "form-check-inline": !stacked })}>
                        <input
                            className="form-check-input"
                            id={optId}
                            type="checkbox"
                            checked={!!formState[optionName]}
                            name={optionName}
                            disabled={!!disabled}
                            onChange={(event) => onChange(event, optionName, event.target.checked)}
                        />
                        <label className="form-check-label" htmlFor={optId}>
                            {opt.label}
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

export default CheckboxInput;
